import React from 'react';
import { useEffect, useState } from 'react';
import './ScrollToTopButton.scss';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button className="scroll-top-btn" onClick={scrollToTop}>
      <leaf-icon name="arrow-upward"></leaf-icon>
      Top
    </button>
  );
};

export default ScrollToTopButton;
